import { Controller } from "@hotwired/stimulus"

// Carousel automatique pour mode TV
export default class extends Controller {
  static targets = ["page", "indicator", "title"]
  static values = {
    interval: { type: Number, default: 15000 }, // 15 secondes
    pauseDuration: { type: Number, default: 10000 }, // 10 secondes après update
    autoRotate: { type: Boolean, default: true }
  }

  connect() {
    this.currentIndex = 0
    this.isPaused = false

    if (this.autoRotateValue && this.pageTargets.length > 1) {
      this.startRotation()
    }

    this.listenToUpdates()
    this.showPage(0)
  }

  disconnect() {
    this.stopRotation()
  }

  startRotation() {
    if (this.rotationTimer) {
      clearInterval(this.rotationTimer)
    }

    this.rotationTimer = setInterval(() => {
      if (!this.isPaused) {
        this.nextPage()
      }
    }, this.intervalValue)
  }

  stopRotation() {
    if (this.rotationTimer) {
      clearInterval(this.rotationTimer)
      this.rotationTimer = null
    }
  }

  nextPage() {
    this.currentIndex = (this.currentIndex + 1) % this.pageTargets.length
    this.showPage(this.currentIndex)
  }

  previousPage() {
    this.currentIndex = (this.currentIndex - 1 + this.pageTargets.length) % this.pageTargets.length
    this.showPage(this.currentIndex)
  }

  showPage(index) {
    // Masquer toutes les pages
    this.pageTargets.forEach((page, i) => {
      if (i === index) {
        page.classList.remove('hidden')
        page.classList.add('animate-fade-in')
      } else {
        page.classList.add('hidden')
        page.classList.remove('animate-fade-in')
      }
    })

    // Mettre à jour les indicateurs
    this.updateIndicators(index)

    // Mettre à jour le titre
    this.updateTitle(index)
  }

  updateIndicators(activeIndex) {
    if (!this.hasIndicatorTarget) return

    this.indicatorTargets.forEach((indicator, i) => {
      if (i === activeIndex) {
        indicator.classList.add('bg-padel-blue-500', 'scale-125')
        indicator.classList.remove('bg-gray-300')
      } else {
        indicator.classList.remove('bg-padel-blue-500', 'scale-125')
        indicator.classList.add('bg-gray-300')
      }
    })
  }

  updateTitle(index) {
    if (!this.hasTitleTarget) return

    const page = this.pageTargets[index]
    const bracketName = page.dataset.bracketName || 'Tableau'
    const ongoingCount = parseInt(page.dataset.ongoingCount || '0')

    let titleHTML = `<h1 class="text-xl font-bold text-gray-900">${bracketName}</h1>`

    if (ongoingCount > 0) {
      titleHTML += `<p class="text-sm text-padel-green-600 font-semibold">
        🔴 ${ongoingCount} match${ongoingCount > 1 ? 's' : ''} en cours
      </p>`
    }

    this.titleTarget.innerHTML = titleHTML
  }

  pauseForUpdate(bracketId) {
    // Arrêter la rotation
    this.isPaused = true

    // Trouver la page avec le bracket mis à jour
    const pageIndex = this.pageTargets.findIndex(
      page => page.dataset.bracketId === bracketId
    )

    if (pageIndex !== -1) {
      // Afficher immédiatement cette page
      this.currentIndex = pageIndex
      this.showPage(pageIndex)
    }

    // Reprendre la rotation après pauseDuration
    setTimeout(() => {
      this.isPaused = false
    }, this.pauseDurationValue)
  }

  listenToUpdates() {
    // Écouter les mises à jour Turbo Stream
    document.addEventListener('turbo:frame-load', (event) => {
      const frame = event.target

      // Vérifier si c'est une mise à jour de match
      if (frame.id && frame.id.includes('match_')) {
        // Extraire le bracket ID depuis le contexte
        const bracketId = this.getBracketIdFromContext(frame)

        if (bracketId) {
          this.pauseForUpdate(bracketId)
        }
      }
    })
  }

  getBracketIdFromContext(frame) {
    // Chercher le bracket parent
    let element = frame
    while (element && element !== document.body) {
      if (element.dataset && element.dataset.bracketId) {
        return element.dataset.bracketId
      }
      element = element.parentElement
    }
    return null
  }

  // Actions manuelles (au cas où)
  pause() {
    this.isPaused = true
  }

  resume() {
    this.isPaused = false
  }

  goToPage(event) {
    const index = parseInt(event.currentTarget.dataset.pageIndex)
    if (!isNaN(index)) {
      this.currentIndex = index
      this.showPage(index)

      // Pauser temporairement après interaction manuelle
      this.isPaused = true
      setTimeout(() => {
        this.isPaused = false
      }, this.pauseDurationValue)
    }
  }
}
